module.exports = __webpack_public_path__ + "img/iconProvince2.31fb5f95.svg";